module.exports = __webpack_public_path__ + "img/170_thumbnail.cebf882f.jpg";